import React, {
    Dispatch,
    ReactNode,
    SetStateAction,
    createContext,
    useEffect,
    useState,
} from "react";

import { getLectures } from "../stores/lectures/lecturesSlice";
import { useDispatch } from "../stores";

const unimplementedFunction = () => {
    throw new Error("This function can't be called before it's initialization");
};

type InitialStateType = {
    page: number;
    setPage: Dispatch<SetStateAction<number>>;

    topicIds: number[];
    setTopicIds: Dispatch<SetStateAction<number[]>>;

    areaIds: number[];
    setAreaIds: Dispatch<SetStateAction<number[]>>;

    instructorIds: number[];
    setInstructorIds: Dispatch<SetStateAction<number[]>>;

    date: Nullable<string>;
    setDate: Dispatch<SetStateAction<Nullable<string>>>;

    hasVideo: Nullable<boolean>;
    setHasVideo: Dispatch<SetStateAction<Nullable<boolean>>>;

    searchQuery: string;
    setSearchQuery: Dispatch<SetStateAction<string>>;

    handleInputChange: (value: string) => void;

    handleLoadMore: (value: number) => void;

    handlePageChange: (value: number) => void;

    clearAllFilters: () => void;
    fetchAllLectures: () => void;
};

const initialState = {
    page: 1,
    setPage: unimplementedFunction,

    outlet: 0,
    setOutlet: unimplementedFunction,

    topicIds: [],
    setTopicIds: unimplementedFunction,

    areaIds: [],
    setAreaIds: unimplementedFunction,

    instructorIds: [],
    setInstructorIds: unimplementedFunction,

    date: null,
    setDate: unimplementedFunction,

    hasVideo: null,
    setHasVideo: unimplementedFunction,

    searchQuery: "",
    setSearchQuery: unimplementedFunction,

    searchQueryAsParam: "",
    setSearchQueryAsParam: unimplementedFunction,

    handleInputChange: unimplementedFunction,

    handleLoadMore: unimplementedFunction,

    handlePageChange: unimplementedFunction,

    clearAllFilters: unimplementedFunction,
    fetchAllLectures: unimplementedFunction,
};

// Create the context with the initial state
const LectureListContext = createContext<InitialStateType>(initialState);

export default LectureListContext;

type LectureListContextProviderProps = {
    children: ReactNode;
};

function LectureListContextProvider({
    children,
}: LectureListContextProviderProps) {
    const dispatch = useDispatch();

    const [page, setPage] = useState<number>(1);
    const [topicIds, setTopicIds] = useState<number[]>([]);
    const [areaIds, setAreaIds] = useState<number[]>([]);
    const [instructorIds, setInstructorIds] = useState<number[]>([]);
    const [date, setDate] = useState<Nullable<string>>(null);
    const [hasVideo, setHasVideo] = useState<Nullable<boolean>>(null);
    const [searchQuery, setSearchQuery] = useState<string>("");

    const handleInputChange = (value: string) => {};

    const handleLoadMore = (value: number) => {};

    const handlePageChange = (pageNumber: number) => {
        setPage(pageNumber);
    };

    const clearAllFilters = () => {
        setPage(1);
        setAreaIds([]);
        setInstructorIds([]);
        setDate(null);
        setHasVideo(null);
    };

    const fetchAllLectures = () =>
      dispatch(
        getLectures({
          page,
          topicIds,
          areaIds,
          instructorIds,
          date,
        })
      );

    useEffect(() => {
        dispatch(
            getLectures({
                page,
                topicIds,
                areaIds,
                instructorIds,
                date,
            })
        );
    }, [dispatch, page, topicIds, areaIds, instructorIds, date]);

    const initialState: InitialStateType = {
        page,
        setPage,
        topicIds,
        setTopicIds,
        areaIds,
        setAreaIds,
        instructorIds,
        setInstructorIds,
        date,
        setDate,
        hasVideo,
        setHasVideo,
        searchQuery,
        setSearchQuery,
        handleInputChange,
        handleLoadMore,
        handlePageChange,
        clearAllFilters,
        fetchAllLectures,
    };

    return (
        <LectureListContext.Provider value={initialState}>
            {children}
        </LectureListContext.Provider>
    );
}

export { LectureListContextProvider };
